<mode-toast
  type="success"
  [showCloseBtn]=true
  [closeBtnPosition]="'top'"
  [hideIcon]="true"
  (dismissToast)="remove()"
  [canTapToDismiss]="false"
>
  <div class="feedback-toast-content">
    <capra-icon class="success-icon" icon="icon-check"></capra-icon>
    <div class="toast-body">
      <h4 class="title">Marked unhelpful.</h4>
      <p class="success-message">
        Thanks for improving AI Assist!
        <span>Want to give feedback on why it wasn't helpful?</span>
      </p>
      <div class="actions">
        <capra-button
          class="dismiss"
          text="Dismiss"
          variant="secondary"
          color="neutral"
          size="small"
          (clicked)="remove()"
        ></capra-button>
        <capra-button
          text="Give feedback"
          variant="secondary"
          color="neutral"
          size="small"
          (clicked)="giveFeedback()"
        ></capra-button>
      </div>
    </div>
  </div>
</mode-toast>
